import {
  fevorvertragsnummer,
  loadAndMigrateState,
  Migrator,
  migrateProduktForVorteilsrabatt,
  migrateProduktnameToEnum,
  migrateZahlungsoptionen,
} from '@ps20-frontend/migrations';
import { IAppState } from '../appState';
import { migrateAssekuranztarif } from './3_migrate_assekuranztarif';
import { migrateSelbstbeteiligung } from './4_migrate_selbstbeteiligung';
import { migrateKooperationsNachlass } from './7_migrate_kooperations-nachlass';

export const stateMigrators: Migrator[] = [
  {
    toVersion: 2,
    migratorFunction: fevorvertragsnummer,
  },
  {
    toVersion: 3,
    migratorFunction: migrateAssekuranztarif,
  },
  {
    toVersion: 4,
    migratorFunction: migrateSelbstbeteiligung,
  },
  {
    toVersion: 5,
    migratorFunction: migrateZahlungsoptionen,
  },
  {
    toVersion: 6,
    migratorFunction: migrateProduktnameToEnum,
  },
  {
    toVersion: 7,
    migratorFunction: migrateKooperationsNachlass,
  },
  {
    toVersion: 8,
    migratorFunction: migrateProduktForVorteilsrabatt,
  },
  {
    toVersion: 9,
    migratorFunction: migrateProduktForVorteilsrabatt,
  },
  {
    toVersion: 10,
    migratorFunction: migrateProduktForVorteilsrabatt,
  },
];

export const loadAndMigrateRsState = (
  currentState: IAppState,
  loadedState: { version: number },
  beibehalten?: boolean,
) => loadAndMigrateState(currentState, loadedState, stateMigrators, beibehalten);
